import React from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'

class Modal extends React.Component {

  static propTypes = {
    isVisible:  PropTypes.bool,
    label:      PropTypes.string.isRequired,
    onClose:    PropTypes.func.isRequired,
    children:   PropTypes.element,
  }

  static style = {
    overlay: {
      position:         'fixed',
      top:              0,
      left:             0,
      right:            0,
      bottom:           0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)'
    },
    content: {
      position:                'absolute',
      top:                     '50%',
      left:                    '50%',
      transform:               'translate(-50%, -50%)',
      right:                   'initial',
      bottom:                  'initial',
      border:                  'initial',
      background:              null,
      overflow:                'initial',
      WebkitOverflowScrolling: 'initial',
      borderRadius:            'initial',
      outline:                 'initial',
      padding:                 'initial',
    }
  }

  static contentStyle = {
    backgroundColor: '#FFFFFF',
    borderRadius: '5px',
  }

  componentWillMount() {
    ReactModal.setAppElement('body')
  }

  render() {
    const { children, isVisible, onClose, label } = this.props

    return (
      <ReactModal
        isOpen={ isVisible }
        contentLabel={ label }
        style={ this.constructor.style }
        className="content_container"
        overlayClassName="overlay_screen overlay_screen_active"
        onRequestClose={ onClose }>
        <div className="content_detail" style={ this.constructor.contentStyle }>
          {/* TODO: Remove auth specific styles from modal */}
          <a className="signupform-close" onClick={ onClose }>Close</a>
          { children }
        </div>
      </ReactModal>
    )
  }
}


export { Modal }
